export default {
  // 審批前臺信息
  approval: {
    launched: '我發起的',
    waitme: '待我審批',
    haveApproval: '我已審批',
    ccme: '抄送給我',
    theme: '主題',
    applytime: '申請時間',
    closingTime: '審結時間',
    version: '版本',
    currentApproverUser: '當前審批人',
    type: '類型',
    status: '審批狀態',
    addApproval: '新增審批',
    nextApprover: '下壹環節審批人',
    chooseMember: '選擇成員',
    chooseDepartment: '選擇部門',
    dynamicParameter: '動態參數',
    pendingApproval: '待審批',
    approvaling: '審批中',
    approvalPast: '審批通過',
    papprovalReject: '審批駁回',
    rescinded: '已撤銷',
    toBeInitiated: '待發起',
    toBeSubmit: '待提交',
    transTo: '已轉交',
    admin: '管理員',
    nodeApproverFrom: '將節點審批人從',
    modifiedTo: '修改為',
    alreadyWaited: '已等待',
    pleaseSignHere: '請在此手寫簽名',
    handSignature: '手寫簽名',
    inner: '內',
    duplicateData: '存在重復的數據',
    pleaseCheck: '請檢查',
    pass: '通過',
    reject: '駁回',
    passOn: '轉交',
    CC: '抄送',
    urge: '催辦',
    revoke: '撤銷',
    originalResume: '原始簡歷',
    unknown: '未知',
    approvalProcess: '審批流程',
    copyPerson: '抄送人',
    ruleCondition: '規則條件',
    passAndEnd: '通過且結束',
    passAndTransfer: '通過並轉審',
    needAppointNextApprlval: '需要指定下壹審批人',
    signature: '簽名',
    clickSignature: '點擊簽名',
    rejectionMode: '駁回方式',
    rejectedNode: '駁回節點',
    approvalOpinion2001: '請輸入駁回意見（200字以內，非必填）',
    approvalOpinion200: '請輸入審批意見（200字以內，非必填）',
    approvalOpinion501: '請輸入提醒內容（50字以內）',
    approvalOpinion502: '請輸入轉交理由（50字以內，非必填）',
    urgeReason: '催辦原因',
    approvalOpinion: '審批意見',
    passOnReason: '轉交理由',
    cexiaohou01: '撤銷後，該審批將從審批人、抄送人處撤回，審批流程將會直接終止',
    determineRevoke: '你確定要撤銷嗎?',
    Approver: '審批人',
    nextStep: '下壹環節',
    passFreeFlow: '通過-自由流程',
    approverNotEmpty: '審批人不能為空',
    approvalSuccess: '審批成功',
    passOnSuccess: '轉交成功',
    urgeSuccess: '催辦成功',
    revokeSuccess: '撤銷成功',
    CCSuccess: '抄送成功',
    rejectSuccess: '駁回成功',
    urgeNotEmpty: '催辦原因不能為空',
    copyPersonNotEmpty: '抄送人不能為空',
    rejectNodeNotEmpty: '駁回節點不能為空',
    chooseApprovalType: '選擇審批類型',

    // 2020-11-16增加新的國家化字段
    dismissApproval: '免審-系統自動審批通過',
    intelligentRobot: '智能機器人',
    rejectionContent: '駁回原因'
  }
}
